import { useState } from 'react';

import { DisplayComponent } from '@/components/DisplayComponent';
import { DisplayHeading } from '@/components/DisplayHeading';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';
import {
    ELoanUsage,
    selectIsVehicleRegistrationKnown,
    selectVehicleAssetType,
} from '@/context/borrower';
import { store } from '@/context/store';
import { useAppSelector } from '@/context/storeHooks';
import { RegoKnown } from '@/UserInput/RegoKnown';
import { VehicleCondition } from '@/UserInput/VehicleCondition';
import { isCar, isCaravan } from '@/utils/glassGuideHelpers';
import { userFacingAssetTitle } from '@/utils/userFacingAssetTitle';

import { VehicleButtons } from './VehicleButtons';
import { VehicleDetailsRegoKnown } from './VehicleDetailsRegoKnown';
import { VehicleDetailsRegoUnKnown } from './VehicleDetailsRegoUnknown';

export const testId = 'Vehicle';

export function Vehicle(): JSX.Element {
    // ***** CONSTANTS *****
    const baseId = 'screen-vehicleDetails';
    const isRegistrationKnown = useAppSelector(
        selectIsVehicleRegistrationKnown
    );
    const assetType = useAppSelector(selectVehicleAssetType);
    const [showErrors, setShowErrors] = useState(false);
    const assetTitle = userFacingAssetTitle();
    const state = store.getState();
    const isNovatedLease =
        state.borrowerReducer.loan.loanUsage === ELoanUsage.NOVATED;
    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
            <ProgressBar />
            <DisplayHeading
                title={`Select ${assetTitle}`}
                infoText={`Select your ${assetTitle.toLowerCase()} below to get an accurate quote`}
            />
            {isNovatedLease && (
                <VehicleCondition showErrors={false} baseId={baseId} />
            )}
            {isCar(assetType) && (
                <RegoKnown showErrors={false} baseId={baseId} />
            )}
            {isRegistrationKnown && !isCaravan(assetType) ? (
                <VehicleDetailsRegoKnown showErrors={showErrors} />
            ) : (
                <VehicleDetailsRegoUnKnown showErrors={showErrors} />
            )}
            <VehicleButtons setShowErrors={setShowErrors} baseId={baseId} />
            </DisplayComponent>
        </div>
    );
}
